<form class="providerForm">

  <div class="row ">
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 button-padding-left">
      <p role="heading" aria-level="1"> Please enter any information you have regarding the {{ title }} </p>
    </div>
  </div>

  @if (isNameRequired) {
    <div class="row ">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <span class="col-form-label" style="font-size: 14px;"> First Name and Last Name Required </span>
      </div>
    </div>
  }

  <div class="row " role="form">
    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
      <div class="col-md-10">
        <form [formGroup]="nonEnumeratedIndividualFormPart1">
          @if (isformloaded) {
            <app-json-form [controlsData]="nonEnumeratedIndividualFormData1.controls" [formData]="nonEnumeratedIndividualFormPart1"
              (valueChangeEvent)="valueChange($event)" (InitializationCompletedEvent)="childInitComplete()"
            ></app-json-form>
          }
        </form>

      </div>
    </div>

    <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
      <div class="col-md-10">
        <form [formGroup]="nonEnumeratedIndividualFormPart2">
          @if (isformloaded) {
            <app-json-form
            [controlsData]="nonEnumeratedIndividualFormData2.controls" [formData]="nonEnumeratedIndividualFormPart2" (valueChangeEvent)="valueChange($event)" (InitializationCompletedEvent)="childInitComplete()" ></app-json-form>
          }
        </form>
      </div>
    </div>
  </div>
</form>